import PropTypes from 'prop-types';
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '@/constants/support';

/**
 * Card network logos + the trust line shown at the bottom of checkout forms.
 *
 * The line says only what the Security Center (/security/payments) and the
 * concierge's knowledge base back up: the checkout is encrypted (HTTPS) and
 * Defera never stores complete card details. It used to read "Bank-level
 * 256-bit SSL secure", a marketing phrase nothing on our side can verify.
 */
export const CHECKOUT_TRUST_LINE = 'Encrypted checkout · We never store your full card number';

/** The words before the number in the checkout's phone line. */
export const CHECKOUT_TALK_TO_TEAM = 'Have questions? Talk to our team';

/**
 * The phone line under the checkout's payment form (founder, 2026-10-24:
 * the phone line, answered 24/7, is promoted ahead of chat). Review renders
 * it once, below the form, so it is not part of the footer.
 */
export function CheckoutTalkToTeam({ className = '' }) {
  return (
    <p className={`text-[13px] font-normal text-white/70 text-center ${className}`}>
      {CHECKOUT_TALK_TO_TEAM}{' '}
      <a
        href={SUPPORT_PHONE_TEL}
        className="font-medium text-white whitespace-nowrap underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors"
      >
        {SUPPORT_PHONE_DISPLAY}
      </a>
    </p>
  );
}

CheckoutTalkToTeam.propTypes = { className: PropTypes.string };

export default function CheckoutPaymentTrustFooter({ className = '' }) {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img src="/extended_image.png" alt="Accepted payment cards" className="h-6 object-contain" />
      <p className="text-white/40 text-[10px] font-normal mt-2">{CHECKOUT_TRUST_LINE}</p>
    </div>
  );
}

CheckoutPaymentTrustFooter.propTypes = { className: PropTypes.string };
